<div class="content pushdown" [class.web]="isWeb()">
  <h1>Your profile</h1>
  <p class="label">Log in to order.</p>
  <app-button [size]="isWeb() ? 'default' : 'large'" label="Log in" (clicked)="login()" />
  <p class="link">Don't have an account? <span (click)="login()">Sign up</span></p>
</div>
<div class="list">
  @if (onMobile()) {
    <app-row route="device-permissions" icon="phone-portrait-sharp" label="Device Permissions" />
  }
  <app-row route="settings" [border]="true" icon="settings-outline" label="Settings" />
  <app-row (click)="getHelp()" icon="help-buoy-outline" [border]="false" label="Help" />
</div>